import angular from 'angular'

const component = angular.module('app.components.templateTree', [])

function getTaxNameByCode() {

}
function findIndexByKey(arr, obj, key) {
    let item
    for (let i = 0; i < arr.length; i += 1) {
        item = arr[i]
        if (item[key] === obj[key]) {
            return i
        }
    }
    return -1
}
function templateTreeService(httpRequest) {
    this.getTemplateByArea = function getTemplateByArea(areaCode) {
        httpRequest.get_getModelByDqSz(areaCode).then((res) => {
            const list = res.data.value
            list.forEach((item) => {

            })
        })
    }
    this.getTemplateByOrg = function getTemplateByOrg() {
        return httpRequest.get_getOrgModel().then((res) => {
            const list = res.data.value
            if (list.length == 0) return
            const result = {
                arr: [],
                cityName: list[0].sfdqqm,
                obj: {
                    sjsfdqDm: list[0].sjsfdqDm,
                    sfdqDm: list[0].sfdqDm,
                },
            }
            let treeNode
            let index
            list.forEach((template) => {
                template.nodeId = template.mbuuid
                template.nodeName = template.mbmc
                treeNode = {
                    nodeName: template.zsxmDmMc,
                    nodeId: template.zsxmDm,
                    children: [],
                }
                index = findIndexByKey(result.arr, treeNode, 'nodeId')
                if (index < 0) {
                    treeNode.children.push(template)
                    result.arr.push(treeNode)
                } else {
                    result.arr[index].children.push(template)
                }
            })
            return result
        })
    }
}

templateTreeService.$inject = ['httpRequest']

component.service('templateTreeService', templateTreeService)

component.component('templateTree', {
    bindings: {
        onSelect: '&',
        level: '<', // 有只选择到税种的
        treeData: '<',
    },
    template: `
        <treecontrol class="tree-light" tree-model="$ctrl.treeData" options="$ctrl.treeOptions" 
            on-selection="$ctrl.select(node)"
            expanded-nodes="$ctrl.treeData">
            {{ node.nodeName }}
        </treecontrol>
    `,
    controller: [function templateTreeCtrl() {
        this.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: false,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8',
            },
        }
        this.select = function select(node) {
            this.onSelect({ node })
        }
    }],
})
export default component.name



// WEBPACK FOOTER //
// ./src/components/templateTree/index.js